<!-- 学校-自建课程 -->
<template>
<div class="container">
    <div class="index" v-if="!detail.show && !add.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>

        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<!-- <el-form-item label="">
                    <el-select v-model="queryParams.state" clearable placeholder="请选择审核状态" class="label">
                        <el-option v-for="(item,i) in stateList" :key="i+'sh'" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
				<el-form-item label="">
                    <el-input type="text" placeholder="请输入课程名称" clearable
                    @clear="getDataList" v-model="queryParams.cname"></el-input>
                </el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
					<el-button size="small" @click='toAdd()'>创建课程</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="a" label="课程封面" align="center">
						<template slot-scope="scope">
							<img :src="scope.row.coverUrl" style="height:42px" alt="">
                        </template>
                    </el-table-column>
                    <el-table-column prop="cname" width="120" label="课程名称" show-overflow-tooltip align="center">
                    </el-table-column>
                    <el-table-column prop="typeName" label="课程类型" show-overflow-tooltip align="center">
                    </el-table-column>
					<!-- <el-table-column prop="teacherName" label="授课教师" show-overflow-tooltip align="center">
                    </el-table-column> -->
                    <el-table-column prop="scope" label="适用年级" show-overflow-tooltip align="center">
						<template slot-scope="scope">
							<p>{{getGrade(scope.row.scope)}}</p>
						</template>
                    </el-table-column>
					<el-table-column prop="periodTotal" label="课时总数" align="center">
						<template slot-scope="scope">
							<p>{{scope.row.periodTotal}}课时</p>
						</template>
                    </el-table-column>
					<el-table-column prop="periodTime" label="课时时长" align="center">
						<template slot-scope="scope">
							<p>{{scope.row.periodTime}}分钟</p>
						</template>
                    </el-table-column>
                    <el-table-column prop="frequency" label="上课频率" align="center">
						<template slot-scope="scope">
							<p>{{scope.row.frequency}}次/周</p>
						</template>
                    </el-table-column>
					<!-- <el-table-column prop="auditState" label="审核状态" align="center">
						<template slot-scope="scope">
							<p>{{stateObj[scope.row.auditState]}}</p>
						</template>
                    </el-table-column> -->
					<el-table-column prop="createTime" label="创建时间" show-overflow-tooltip align="center" >
						<template slot-scope="scope">
							<!-- HH:mm -->
							{{dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm')}}
						</template>
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" fixed="right" width="250">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看详情</el-button>
							<el-button v-if="scope.row.joinSmartCampus!='0'" type="text" size="small" @click="removecourse(scope.row, '确定移除校本选课吗?')">移除校本选课</el-button>
							<template v-if="scope.row.joinSmartCampus=='0'">
							<el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
							<el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
							<el-button type="text" size="small" @click="joincourse(scope.row, '确定加入校本选课吗?')">加入校本选课</el-button>
							</template>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" :type="'school'"  @to-index="toIndex"></Detail>
	<Add :info.sync="add.info" v-show="add.show" @to-index="toIndex" @to-init="init"></Add>
</div>
</template>
<script>
import schoolApi from '@/api/schoolApi/index.js'
import { getDetail, submitaudit, handleDelete, } from '@/api/mechanismApi/curriculum.js'
import util from '@/utils/util.js'
import dayjs from "dayjs";
import educationApi from '@/api/education/index.js'
export default {
    components:{
        Detail: ()=>import('../allCourse/detail.vue'),
		Add: ()=>import('./add.vue'),
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				cname:'',
				state:'',
			},
			stateList:[
				{id:'0',label:'未送审'},
				{id:'1',label:'待审核'},
				{id:'2',label:'审核通过'},
				{id:'3',label:'审核不通过'},
				{id:'4',label:'已下架'},
			],
			stateObj: {
				'0':'未送审',
				'1':'待审核',
				'2':'审核通过',
				'3':'审核不通过',
				'4':'已下架',
			},
			tableData: [],
            detail:{
                info:{},
                show:false,
            },
			add:{
				info:{},
                show:false,
			},
		}
	},
	watch:{
		
	},
	created() {
		this.getDataList();
	},
	methods: {
		dayjs,
		init(){
			this.queryParams = {
				grade:'',
				date:'',
				state:'',
			};
			this.pageNum=1;
			this.getDataList();
		},
		getGrade(scope){
			if(!scope) return '';
			return util.getGrade(scope)
		},
		async getDataList() {
			let params = {
				pageNum:this.pageNum,
				pageSize:this.pageSize,
				auditState:this.queryParams.state,
				cname:this.queryParams.cname,
			}
			let res = await schoolApi.getSchoolCourseSelfList(params);
			if(res.result==='000000'){
				this.tableData=res.data?.list || [];
				this.totalPage=res.data?.total || 0;
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        async toDetail(item){
			let params = {
				id: item.cid,
			};
			let paramsData= {
			cid: item.cid,
			orgId:sessionStorage.getItem("orgId"),
			};
			var { result,data } = await getDetail(params);
			let res= await educationApi.getEducationCourseauditrecord(paramsData);
			if (result == "000000") {
				this.detail.info = data;
				if(res.result==='000000'){
					if (res.data.length != 0) {
						this.detail.info.operateList=res.data || [];
					}else{
						this.detail.info.operateList=[{
							auditState: "",
							operateOpinion: "无审核记录",
							operateOrgName: "",
						}]
					}
				}
				this.detail.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
        },
        toIndex(){
            this.detail.show=false;
			this.add.show=false;
        },
		async edit(item){
			let params = {
				id: item.cid,
			};
			var { result,data } = await getDetail(params);
			if (result == "000000") {
				this.add.info = data;
				this.add.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
		},
		// 加入校本选课
		async joincourse(item, text, type){
			let vm=this;
			util.handleCofirm(text, 'info',).then(async res => {
				let params = {
					loginPlatformCode: sessionStorage.getItem("loginPlatformCode"),
					platformCode: sessionStorage.getItem("platformCode"),
					usessionid: sessionStorage.getItem("usessionid"),
					cid: item.cid,
				};
				var { result } = await schoolApi.schoolCourseJoincourse(params);
				if (result == "000000") {
					vm.$message({
						type: "success",
						message: "操作成功",
					});
					vm.getDataList();
				} else {
					vm.$message({
						type: "error",
						message: "操作失败",
					});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
		},
		// 取消加入校本选课
		async removecourse(item, text, type){
			let vm=this;
			util.handleCofirm(text, 'info',).then(async res => {
				let params = {
					loginPlatformCode: sessionStorage.getItem("loginPlatformCode"),
					platformCode: sessionStorage.getItem("platformCode"),
					usessionid: sessionStorage.getItem("usessionid"),
					cid: item.cid,
				};
				var { result } = await schoolApi.schoolCourseRemovecourse(params);
				if (result == "000000") {
					vm.$message({
						type: "success",
						message: "操作成功",
					});
					vm.getDataList();
				} else {
					vm.$message({
						type: "error",
						message: "操作失败",
					});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
		},
		async del(item){
			let vm=this;
			util.handleCofirm('确定要删除课程吗?', 'info',).then(async res => {
				let params = {
					cid: item.cid,
				};
				var { result } = await handleDelete(params);
				if (result == "000000") {
					vm.$message({
						type: "success",
						message: "操作成功",
					});
					vm.getDataList();
				} else {
					vm.$message({
						type: "error",
						message: "操作失败",
					});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
		},
		toAdd(){
			this.add.info.cid=null;
			this.add.show=true;
		},
	},
	mounted() {
		
	},
}
</script>
<style lang="less" scoped>
.container{
	width: 100%;
	height: 100%;
	overflow: hidden;
}
.index {
	width: 100%;
	height: 100%;
    padding: 0 30px 30px;
	overflow: auto;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 200px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
